import { useEffect, useState } from "react";
import { piKey } from "./useURLParams.sideEffects.js";
import {
  indicatorLog,
  getData,
} from "../../functions/helper/helpers.functions.js";
import { setBundledProperties } from "../../components/mapUi/mapbox/variables/layerProperties.js";
import { setJSCustomLayerValues } from "../../components/mapUi/mapbox/variables/CUSTOMIZABLE_VALUES.js";
export let CUSTOM_STYLE_PATH =
  process.env.REACT_APP_GET_CUSTOM_STYLE_PATH + `${piKey}/design/`;
/**
 * Lädt CSS Styles nach
 */
export default function useStyles(props) {
  const id = "loadedStyle";

  const [attempt, setAttempt] = useState(0);
  const [designPath, setDesignPath] = useState(null);

  useEffect(() => {
    // initial ist customStyleId undefined im reducer
    if (props.customStyleId === undefined || !piKey) return;

    if (props.customStyleId === null) {
      // wenn keine CustomId aus der URL geholt werden kann -> normaler design Ordner
      CUSTOM_STYLE_PATH =
        process.env.REACT_APP_GET_CUSTOM_STYLE_PATH + `${piKey}/design/`;
    } else {
      // bei customId -> custom Design Ordner
      CUSTOM_STYLE_PATH =
        process.env.REACT_APP_GET_CUSTOM_STYLE_PATH +
        `${piKey}/design/${props.customStyleId}/`;
    }
    setDesignPath(CUSTOM_STYLE_PATH);
  }, [props.customStyleId, piKey, props.piKeyState]);

  // Lade die Color JSON aus navigationProductData
  useEffect(() => {
    if (
      !props.introComplete ||
      !designPath ||
      props.serviceWorkerActive == null
    )
      return;

    const colorsJSONPath = designPath + "jsColors/mainColors.json";
    getData(colorsJSONPath)
      .then((result) => {
        setJSCustomLayerValues(result);
        setBundledProperties();
        props.setDesignDataLoaded(true);
        props.getSessionKey();

        indicatorLog("mainColors.json erhalten und gesetzt 🎨");
      })
      .catch((error) => {
        setBundledProperties();
        indicatorLog(
          "Leider konnte die mainColors.json nicht geladen werden. Bitte überprüfe den zuständigen Ordner, alle Informationen stehen in der readMe.md",
          { background: "red", error: error }
        );
        props.setDesignDataLoaded(false);
        props.getSessionKey();
      });
  }, [props.introComplete, designPath, props.serviceWorkerActive]);

  useEffect(() => {
    if (!designPath) return;

    const path = designPath + "scss/main.css?v=2";
    const type = "css";

    loadFile(path, type, id, attempt, setAttempt);
    // props.getSessionKey();
  }, [props.serverDataLoaded, designPath]);
}

/**
 * File Loader
 * @param path
 * @param {"css", "js"}type
 */
function loadFile(path, type, id, attempt, setAttempt) {
  // soll nur einmal mal machen
  if (attempt > 0) return;
  setAttempt(1);
  let fileref;
  if (type === "js") {
    fileref = document.createElement("script");
    fileref.setAttribute("type", "text/javascript");
    fileref.setAttribute(`src`, path);
    fileref.setAttribute("id", id + attempt);
  } else if (type === "css") {
    fileref = document.createElement("link");
    fileref.setAttribute("rel", "stylesheet");
    fileref.setAttribute("type", "text/css");
    fileref.setAttribute(`href`, path);
    fileref.setAttribute("id", id + attempt);
  }
  document.getElementsByTagName("head")[0].appendChild(fileref);
}
